/**
 * Created by Ning Jiang on 3/3/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig, SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {WildNudgeGameConfig} from "../WildNudgeGameConfig";
import {WildNudgeSoundConfig} from "../WildNudgeSoundConfig";
import {BurningReelSymbol} from "./BurningReelSymbol";

export class BurningMReelSymbol extends BurningReelSymbol {

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === WildNudgeGameConfig.instance.SYMBOL_STATES.attention.keyword) {
            timeline.add(() => this.playFireOverlay(), delay);
        }
    }

    protected createFireOverlay():TimelineSprite {
        const fire:TimelineSprite = new TimelineSprite(GameResources.getTextures(`${this.stackedSymName!.symName}_fire`), 20);
        fire.anchor.set(0.5, ((this.stackedSymName!.index + 0.5) * GameConfig.instance.SYMBOL_HEIGHT + 359) / 928);
        fire.scale.set(2, 2);
        fire.blendMode = PIXI.BLEND_MODES.ADD;

        return fire;
    }

    protected playFireSound():void {
        SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.FLY_BY_FIRE);
    }
}